module.exports = __webpack_public_path__ + "static/media/ANDROS II PHONOSTAGE.3661f4ca.png";